import script from "./everyone-collect-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./everyone-collect-page.vue?vue&type=script&setup=true&lang=ts"

import "./everyone-collect-page.vue?vue&type=style&index=0&id=6c65213c&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c65213c"]])

export default __exports__